// src/components/CustomerForm.js
import React from 'react';
// ✅ ایمپورت کردن کامپوننت اختصاصی تاریخ شمسی
import JalaliDatePicker from './JalaliDatePicker'; 

const CustomerForm = ({ customerData, onCustomerChange, isPhoneValid, isPhoneFocused, onPhoneFocus, onPhoneBlur }) => {
  const styles = {
    formContainer: { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '1rem' // Was 1.5rem
    },
    title: { 
        fontSize: '1rem', // Was 1.5rem
        fontWeight: 'bold', 
        color: '#f8f9fa', 
        textAlign: 'center', 
        marginBottom: '0.67rem' // Was 1rem
    },
    inputGroup: { 
        display: 'flex', 
        flexDirection: 'column' 
    },
    label: { 
        marginBottom: '0.34rem', // Was 0.5rem
        color: '#e0d6d6ff', 
        fontSize: '0.6rem' // Was 0.9rem
    },
    input: { 
        padding: '0.5rem', // Was 0.75rem
        fontSize: '0.9rem', // Was 1rem
        border: '1px solid #ccc', 
        borderRadius: '3px' // Was 4px
    },
    instructions: {
        fontSize: '0.5rem', // Was 0.75rem
        borderRadius: '0.34rem', // Was 0.5rem
        background: '#f8d7da',
        color: '#721c24',
        padding: '0.34rem', // Was 0.5rem
        position: 'relative',
        bottom: '-7px' // Was -10px
    },
    offscreen: { 
        display: 'none' 
    }
};

  const handleChange = (e) => {
    const { name, value } = e.target;
    onCustomerChange(prevData => ({ ...prevData, [name]: value }));
  };
  
  // ✅ یک تابع ساده برای به‌روزرسانی تاریخ از کامپوننت JalaliDatePicker
  const handleDateChange = (dateString) => {
    onCustomerChange(prevData => ({ ...prevData, dueDate: dateString }));
  };

  return (
    <div style={styles.formContainer}>
      <h2 style={styles.title}>اطلاعات مشتری</h2>
      
      <div style={styles.inputGroup}>
        <label style={styles.label} htmlFor="fullName">نام و نام خانوادگی</label>
        <input style={styles.input} type="text" id="fullName" name="fullName" value={customerData.fullName} onChange={handleChange} />
      </div>
      
      <div style={styles.inputGroup}>
        <label style={styles.label} htmlFor="phoneNumber">شماره تلفن</label>
        <input style={styles.input} type="tel" id="phoneNumber" name="phoneNumber" value={customerData.phoneNumber} onChange={handleChange} 
               onFocus={onPhoneFocus} onBlur={onPhoneBlur} required aria-invalid={!isPhoneValid} />
        <p style={isPhoneFocused && customerData.phoneNumber && !isPhoneValid ? styles.instructions : styles.offscreen}>
          ℹ️ شماره تلفن همراه باید ۱۱ رقمی بوده و با 09 شروع شود.
        </p>
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label} htmlFor="serviceNumber">شماره سرویس</label>
        <input style={styles.input} type="text" id="serviceNumber" name="serviceNumber" value={customerData.serviceNumber} onChange={handleChange} />
      </div>

      {/* ✅ جایگزینی بسیار ساده‌تر با کامپوننت جدید */}
      <div style={styles.inputGroup}>
        <label style={styles.label} htmlFor="dueDate">تاریخ سررسید</label>
        <JalaliDatePicker 
          value={customerData.dueDate}
          onChange={handleDateChange}
          placeholder="تاریخ را انتخاب کنید..."
        />
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label} htmlFor="maxDailyMessages">حداکثر پیام روزانه</label>
        <input style={styles.input} type="number" id="maxDailyMessages" name="maxDailyMessages" value={customerData.maxDailyMessages} onChange={handleChange} />
      </div>

      <div style={styles.inputGroup}>
        <label style={styles.label} htmlFor="digit_format">فرمت نمایش اعداد</label>
        <select style={styles.input} id="digit_format" name="digit_format" value={customerData.digit_format || 'english'} onChange={handleChange}>
          <option value="english">انگلیسی (English)</option>
          <option value="persian">فارسی (Persian)</option>
        </select>
      </div>

    </div>
  );
};

export default CustomerForm;